import { render, staticRenderFns } from "./Vquestion.vue?vue&type=template&id=02818e5a"
import script from "./Vquestion.vue?vue&type=script&lang=js"
export * from "./Vquestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports